import {Component, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {CoreConfigService} from '../../../@core/services/config.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {CourseService} from '../../shared/services/course.service';
import {StudentService} from '../../shared/services/student.service';
import {GlobalService} from '../../shared/services/global.service';
import {StorageService} from '../../shared/services/storage.service';
import {LandingPageAboutUsService} from '../../shared/services/landing-page-about-us.service';
import {environment} from '../../../environments/environment';
import {LandingPageSliderService} from '../../shared/services/landing-page-slider.service';
import {LandingPageCourseService} from '../../shared/services/landing-page-course.service';
import {LandingPageWhyUsService} from '../../shared/services/landing-page-why-us.service';
import {LandingPageContactUsService} from '../../shared/services/landing-page-contact-us.service';
import {Title} from '@angular/platform-browser';
import {UniversityService} from '../../shared/services/university.service';
import {CoreConfig} from '../../../@core/types';
import {AlertService} from '../../shared/services/alert.service';

@Component({
    selector: 'app-landing-page',
    templateUrl: './landing-page.component.html',
    styleUrls: ['./landing-page.component.scss']
})

export class LandingPageComponent implements OnInit {
    user: any;
    private _unsubscribeAll: Subject<any>;
    landingSliders: any = {
        one: 'assets/images/image-backgrounds/1600-800.png',
        two: 'assets/images/image-backgrounds/1600-800.png',
        three: 'assets/images/image-backgrounds/1600-800.png',
        four: 'assets/images/image-backgrounds/1600-800.png',
        five: 'assets/images/image-backgrounds/1600-800.png',
        six: 'assets/images/image-backgrounds/1600-800.png'
    };
    slider1Data: any;
    slider2Data: any;
    slider3Data: any;
    slider4Data: any;
    slider5Data: any;
    slider6Data: any;
    addStudentForm: FormGroup;
    courses: [];
    aboutUsData: any;
    aboutUsImage: any = 'assets/images/image-backgrounds/500-300.png';
    aboutUsText: any = 'Text about univeristy, will appear here.';
    updateCourseData: any;
    updateWhyUsData: any;
    updateContactUsData: any;
    course1Data: any = {
        'name': 'Course 1',
        'image': 'assets/images/image-backgrounds/500-300.png',
        'info': 'Course 1 Info'
    };
    course2Data: any = {
        'name': 'Course 2',
        'image': 'assets/images/image-backgrounds/500-300.png',
        'info': 'Course 2 Info'
    };
    course3Data: any = {
        'name': 'Course 3',
        'image': 'assets/images/image-backgrounds/500-300.png',
        'info': 'Course 3 Info'
    };
    course4Data: any = {
        'name': 'Course 4',
        'image': 'assets/images/image-backgrounds/500-300.png',
        'info': 'Course 4 Info'
    };
    course5Data: any = {
        'name': 'Course 5',
        'image': 'assets/images/image-backgrounds/500-300.png',
        'info': 'Course 5 Info'
    };
    course6Data: any = {
        'name': 'Course 6',
        'image': 'assets/images/image-backgrounds/500-300.png',
        'info': 'Course 6 Info'
    };
    whyUs1Data: any = {
        'name': 'Why Us 1',
        'image': 'assets/images/image-backgrounds/500-300.png',
        'info': 'Why Us 1 Info'
    };
    whyUs2Data: any = {
        'name': 'Why Us 2',
        'image': 'assets/images/image-backgrounds/500-300.png',
        'info': 'Why Us 2 Info'
    };
    whyUs3Data: any = {
        'name': 'Why Us 3',
        'image': 'assets/images/image-backgrounds/500-300.png',
        'info': 'Why Us 3 Info'
    };
    whyUs4Data: any = {
        'name': 'Why Us 4',
        'image': 'assets/images/image-backgrounds/500-300.png',
        'info': 'Why Us 4 Info'
    };
    mapUrl: any = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3502.536812738167!2d77.10620371551856!3d28.613669191684483!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d0354b155556d%3A0xea671f4267872ff9!2sSHIKSHA%20BHARTI%20PRAKASHAN%20PVT%20LTD!5e0!3m2!1sen!2sin!4v1624367848692!5m2!1sen!2sin';
    contactUsData: any = {
        'address': 'University Address',
        'district': 'University District',
        'state_id': 1,
        'pin_code': 'University Postal Code',
        'state': {'id': 10, 'name': 'University State'},
        'contact': 'University Contact Number'
    };
    universityData: any;
    profileImage: any;
    counsellorId: any;
    paramsObject: any;

    constructor(public _coreConfigService: CoreConfigService,
                private router: Router,
                private fb: FormBuilder,
                private courseService: CourseService,
                private studentService: StudentService,
                private globalService: GlobalService,
                public landingPageAboutUsService: LandingPageAboutUsService,
                public landingPageSliderService: LandingPageSliderService,
                public landingPageCourseService: LandingPageCourseService,
                public landingPageWhyUsService: LandingPageWhyUsService,
                public landingPageContactUsService: LandingPageContactUsService,
                public universityService: UniversityService,
                public alertService: AlertService,
                private titleService: Title,
                public activatedRoute: ActivatedRoute
    ) {
        this._unsubscribeAll = new Subject();
        this._coreConfigService.config = {
            layout: {
                menu: {
                    hidden: true
                },
                animation: 'none',
                customizer: false,
                enableLocalStorage: false,
                type: 'horizontal'
            }
        };
        this.user = this.globalService.getSelf() ? this.globalService.getSelf() : StorageService.getItem('self');
    }

    ngOnInit(): void {
        this.refresh();
    }

    refresh() {
        this.router.navigateByUrl('/auth/login');
        return;
        this.activatedRoute.queryParamMap.subscribe((params) => {
                this.paramsObject = {...params.keys, ...params};
                if (this.paramsObject && this.paramsObject['params'] && this.paramsObject['params'].counsellor) {
                    StorageService.setItem('added_by', this.paramsObject['params'].counsellor);
                }
            }
        );
        this.addStudentForm = this.fb.group({
            'name': ['', Validators.required],
            'email': ['', Validators.required],
            'contact': ['', Validators.required],
            'course_id': ['', Validators.required],
        });
        this.universityDetail();
        this.getCourses();
        this.getLandingSliders();
        this.getLandingAboutUs();
        this.getLandingCourses();
        this.getLandingWhyUs();
        this.getLandingContactUs();
    }

    universityDetail(params: any = {}) {
        this.universityService.detailByLanding(this.user['university_id']).subscribe(data => {
            if (data) {
                this.universityData = data;
                let title = (this.universityData && this.universityData['name']) ? this.universityData['name'].toUpperCase() : 'Landing Page';
                this.titleService.setTitle(title);
                if (data && data['university_detail'] && data['university_detail']['profile_image']) {
                    this.profileImage = data['university_detail']['profile_image'].url;
                }
            }
        });
    }

    getCourses(params: any = {}) {
        if (this.user && this.user['university_id']) {
            this.courseService.getByLanding(this.user['university_id'], params).subscribe(data => {
                if (data && data['data'].length > 0) {
                    this.courses = data['data'];
                } else {
                    this.courses = [];
                }
            });
        }
    }

    getLandingSliders() {
        if (this.user && this.user['university_id']) {
            this.landingPageSliderService.get(this.user['university_id'], {'page': -1}).subscribe(data => {
                if (data && data['data'].length > 0) {
                    let landingSliders = {};
                    let slider1Data: any = undefined;
                    let slider2Data: any = undefined;
                    let slider3Data: any = undefined;
                    let slider4Data: any = undefined;
                    let slider5Data: any = undefined;
                    let slider6Data: any = undefined;
                    data['data'].forEach(data => {
                        if (data['type'] === 'SLIDER_1') {
                            slider1Data = data;
                            landingSliders['one'] = (slider1Data && slider1Data['file'] && slider1Data['file'].url) ? slider1Data['file'].url : '';
                        } else if (data['type'] === 'SLIDER_2') {
                            slider2Data = data;
                            landingSliders['two'] = (slider2Data && slider2Data['file'] && slider2Data['file'].url) ? slider2Data['file'].url : '';
                        } else if (data['type'] === 'SLIDER_3') {
                            slider3Data = data;
                            landingSliders['three'] = (slider3Data && slider3Data['file'] && slider3Data['file'].url) ? slider3Data['file'].url : '';
                        } else if (data['type'] === 'SLIDER_4') {
                            slider4Data = data;
                            landingSliders['four'] = (slider4Data && slider4Data['file'] && slider4Data['file'].url) ? slider4Data['file'].url : '';
                        } else if (data['type'] === 'SLIDER_5') {
                            slider5Data = data;
                            landingSliders['five'] = (slider5Data && slider5Data['file'] && slider5Data['file'].url) ? slider5Data['file'].url : '';
                        } else if (data['type'] === 'SLIDER_6') {
                            slider6Data = data;
                            landingSliders['six'] = (slider6Data && slider6Data['file'] && slider6Data['file'].url) ? slider6Data['file'].url : '';
                        }
                    });
                    if (landingSliders && !landingSliders['one']) {
                        landingSliders['one'] = 'assets/images/image-backgrounds/1600-800.png';
                    }
                    if (landingSliders && !landingSliders['two']) {
                        landingSliders['two'] = 'assets/images/image-backgrounds/1600-800.png';
                    }
                    if (landingSliders && !landingSliders['three']) {
                        landingSliders['three'] = 'assets/images/image-backgrounds/1600-800.png';
                    }
                    if (landingSliders && !landingSliders['four']) {
                        landingSliders['four'] = 'assets/images/image-backgrounds/1600-800.png';
                    }
                    if (landingSliders && !landingSliders['five']) {
                        landingSliders['five'] = 'assets/images/image-backgrounds/1600-800.png';
                    }
                    if (landingSliders && !landingSliders['six']) {
                        landingSliders['six'] = 'assets/images/image-backgrounds/1600-800.png';
                    }
                    this.landingSliders = landingSliders;
                    this.slider1Data = slider1Data;
                    this.slider2Data = slider2Data;
                    this.slider3Data = slider3Data;
                    this.slider4Data = slider4Data;
                    this.slider5Data = slider5Data;
                    this.slider6Data = slider6Data;
                }
            });
        }
    }

    getLandingAboutUs() {
        if (this.user && this.user['university_id']) {
            this.landingPageAboutUsService.get(this.user['university_id'], {'page': -1}).subscribe(data => {
                if (data) {
                    this.aboutUsData = data;
                    if (data && data['data'] && data['data']['file'] && data['data']['file']) {
                        this.aboutUsImage = data['data']['file'].url;
                    }
                    if (data && data['data'] && data['data'].about) {
                        this.aboutUsText = (data['data'] && data['data'].about) ? data['data'].about : '';
                    }
                }
            });
        }
    }

    getLandingCourses() {
        if (this.user && this.user['university_id']) {
            this.landingPageCourseService.get(this.user['university_id'], {'page': -1}).subscribe(data => {
                if (data) {
                    this.updateCourseData = data['data'];
                    this.course1Data = {
                        'file_id': (data['data'] && data['data'].course_1_file_id) ? data['data'].course_1_file_id : '',
                        'name': (data['data'] && data['data'].course_1_name) ? data['data'].course_1_name : '',
                        'info': (data['data'] && data['data'].course_1_info) ? data['data'].course_1_info : '',
                        'image': (data['data'] && data['data'].course_1_file_id) ? (data['data']['course_1_file'].url) : 'assets/images/image-backgrounds/500-300.png'
                    };
                    this.course2Data = {
                        'file_id': (data['data'] && data['data'].course_2_file_id) ? data['data'].course_2_file_id : '',
                        'name': (data['data'] && data['data'].course_2_name) ? data['data'].course_2_name : '',
                        'info': (data['data'] && data['data'].course_2_info) ? data['data'].course_2_info : '',
                        'image': (data['data'] && data['data'].course_2_file_id) ? (data['data']['course_2_file'].url) : 'assets/images/image-backgrounds/500-300.png'
                    };
                    this.course3Data = {
                        'file_id': (data['data'] && data['data'].course_3_file_id) ? data['data'].course_3_file_id : '',
                        'name': (data['data'] && data['data'].course_3_name) ? data['data'].course_3_name : '',
                        'info': (data['data'] && data['data'].course_3_info) ? data['data'].course_3_info : '',
                        'image': (data['data'] && data['data'].course_3_file_id) ? (data['data']['course_3_file'].url) : 'assets/images/image-backgrounds/500-300.png'
                    };
                    this.course4Data = {
                        'file_id': (data['data'] && data['data'].course_4_file_id) ? data['data'].course_4_file_id : '',
                        'name': (data['data'] && data['data'].course_4_name) ? data['data'].course_4_name : '',
                        'info': (data['data'] && data['data'].course_4_info) ? data['data'].course_4_info : '',
                        'image': (data['data'] && data['data'].course_4_file_id) ? (data['data']['course_4_file'].url) : 'assets/images/image-backgrounds/500-300.png'
                    };
                    this.course5Data = {
                        'file_id': (data['data'] && data['data'].course_5_file_id) ? data['data'].course_5_file_id : '',
                        'name': (data['data'] && data['data'].course_5_name) ? data['data'].course_5_name : '',
                        'info': (data['data'] && data['data'].course_5_info) ? data['data'].course_5_info : '',
                        'image': (data['data'] && data['data'].course_5_file_id) ? (data['data']['course_5_file'].url) : 'assets/images/image-backgrounds/500-300.png'
                    };
                    this.course6Data = {
                        'file_id': (data['data'] && data['data'].course_6_file_id) ? data['data'].course_6_file_id : '',
                        'name': (data['data'] && data['data'].course_6_name) ? data['data'].course_6_name : '',
                        'info': (data['data'] && data['data'].course_6_info) ? data['data'].course_6_info : '',
                        'image': (data['data'] && data['data'].course_6_file_id) ? (data['data']['course_6_file'].url) : 'assets/images/image-backgrounds/500-300.png'
                    };
                }
            });
        }
    }

    getLandingWhyUs() {
        if (this.user && this.user['university_id']) {
            this.landingPageWhyUsService.get(this.user['university_id'], {'page': -1}).subscribe(data => {
                if (data) {
                    this.updateWhyUsData = data['data'];
                    this.whyUs1Data = {
                        'file_id': (data['data'] && data['data'].why_us_1_file_id) ? data['data'].why_us_1_file_id : '',
                        'name': (data['data'] && data['data'].why_us_1_name) ? data['data'].why_us_1_name : '',
                        'info': (data['data'] && data['data'].why_us_1_info) ? data['data'].why_us_1_info : '',
                        'image': (data['data'] && data['data'].why_us_1_file_id) ? (data['data']['why_us_1_file'].url) : 'assets/images/image-backgrounds/500-300.png'
                    };
                    this.whyUs2Data = {
                        'file_id': (data['data'] && data['data'].why_us_2_file_id) ? data['data'].why_us_2_file_id : '',
                        'name': (data['data'] && data['data'].why_us_2_name) ? data['data'].why_us_2_name : '',
                        'info': (data['data'] && data['data'].why_us_2_info) ? data['data'].why_us_2_info : '',
                        'image': (data['data'] && data['data'].why_us_2_file_id) ? (data['data']['why_us_2_file'].url) : 'assets/images/image-backgrounds/500-300.png'
                    };
                    this.whyUs3Data = {
                        'file_id': (data['data'] && data['data'].why_us_3_file_id) ? data['data'].why_us_3_file_id : '',
                        'name': (data['data'] && data['data'].why_us_3_name) ? data['data'].why_us_3_name : '',
                        'info': (data['data'] && data['data'].why_us_3_info) ? data['data'].why_us_3_info : '',
                        'image': (data['data'] && data['data'].why_us_3_file_id) ? (data['data']['why_us_3_file'].url) : 'assets/images/image-backgrounds/500-300.png'
                    };
                    this.whyUs4Data = {
                        'file_id': (data['data'] && data['data'].why_us_4_file_id) ? data['data'].why_us_4_file_id : '',
                        'name': (data['data'] && data['data'].why_us_4_name) ? data['data'].why_us_4_name : '',
                        'info': (data['data'] && data['data'].why_us_4_info) ? data['data'].why_us_4_info : '',
                        'image': (data['data'] && data['data'].why_us_4_file_id) ? (data['data']['why_us_4_file'].url) : 'assets/images/image-backgrounds/500-300.png'
                    };
                }
            });
        }
    }

    getLandingContactUs() {
        if (this.user && this.user['university_id']) {
            this.landingPageContactUsService.get(this.user['university_id'], {'page': -1}).subscribe(data => {
                if (data) {
                    this.updateContactUsData = data;
                    this.contactUsData = {
                        'address': (data && data['data'] && data['data'].address) ? data['data'].address : '',
                        'district': (data && data['data'] && data['data'].district) ? data['data'].district : '',
                        'state': (data && data['data'] && data['data'].state) ? data['data'].state : '',
                        'pin_code': (data && data['data'] && data['data'].pin_code) ? data['data'].pin_code : '',
                        'contact': (data && data['data'] && data['data'].contact) ? data['data'].contact : '',
                        'location': (data && data['data'] && data['data'].location_url) ? data['data'].location_url : ''
                    };
                }
            });
        }
    }

    submit() {
        const params = {
            'university_id': (this.user && this.user['university_id']) ? this.user['university_id'] : '',
            'name': (this.addStudentForm.value && this.addStudentForm.value.name) ? this.addStudentForm.value.name : '',
            'email': (this.addStudentForm.value && this.addStudentForm.value.email) ? this.addStudentForm.value.email : '',
            'contact': (this.addStudentForm.value && this.addStudentForm.value.contact) ? this.addStudentForm.value.contact : '',
            'course_id': (this.addStudentForm.value && this.addStudentForm.value.course_id) ? this.addStudentForm.value.course_id : '',
            'added_by': (StorageService.getItem('added_by')) ? StorageService.getItem('added_by') : ''
        };
        this.studentService.studentRegister(params).subscribe(data => {
            if (data) {
                this.addStudentForm.reset();
                this.addStudentForm.patchValue({
                    'name': '',
                    'email': '',
                    'contact': '',
                    'course_id': ''
                });
                this.router.navigateByUrl('auth/login');
            }
        }, error => {
            if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                if (error['error']['errors'].email && error['error']['errors'].email.length > 0) {
                    this.alertService.showErrors(error['error']['errors'].email[0]);
                    return;
                }
                if (error['error']['errors'].contact && error['error']['errors'].contact.length > 0) {
                    this.alertService.showErrors(error['error']['errors'].contact[0]);
                    return;
                }
            }
        });
    }

    navigateTo(url) {
        this.router.navigate([url]).then(() => {
            window.location.reload();
        });
    }
}
